import { Button } from "@/components/ui/button";
import { useUI } from "@/context/UIContext";
import { FaArrowLeft, FaFlask } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const toV2Route = (path: string) => {
  if (path.startsWith("/v2")) return path;
  if (path.startsWith("/matches")) return "/v2/matches";
  if (path.startsWith("/players")) return "/v2/squad";
  if (path.startsWith("/team-generator")) return "/v2/matches";
  if (path.startsWith("/leaderboard") || path.startsWith("/chemistry")) return "/v2/stats";
  return "/v2/home";
};

const toLegacyRoute = (path: string) => {
  if (path.startsWith("/v2/matches")) return "/matches";
  if (path.startsWith("/v2/squad")) return "/players";
  if (path.startsWith("/v2/stats")) return "/legacy/dashboard?tab=leaderboard";
  return "/legacy/dashboard";
};

const UIToggle = () => {
  const { uiMode, setUIMode, showUIToggle } = useUI();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleToggle = () => {
    const currentPath = location.pathname;

    if (uiMode === 'current') {
      setUIMode('experimental');
      navigate(toV2Route(currentPath));
    } else {
      setUIMode('current');
      navigate(toLegacyRoute(currentPath));
    }
  };

  if (!showUIToggle) return null;

  return (
    <Button
      onClick={handleToggle}
      variant="outline"
      size="sm"
      className="fixed bottom-20 right-4 z-50 shadow-sm md:bottom-6 md:right-6"
    >
      {uiMode === 'current' ? (
        <>
          <FaFlask className="h-4 w-4 mr-2" />
          {t("uiToggle.v2Mode")}
        </>
      ) : (
        <>
          <FaArrowLeft className="h-4 w-4 mr-2" />
          {t("uiToggle.legacyMode")}
        </>
      )}
    </Button>
  );
};

export default UIToggle;
